import payment from './payment_reducer';
import purchase from './purchase_reducer';
import transaction_finalization from './transaction_finalization_reducer';

export default {
	payment,
	purchase,
	transaction_finalization
};
